import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

export default  ({description}) => {
        return (
            <div className="bg-gray-light rounded pt-2 pl-1 pb-2 mb-2 row ml-auto mr-auto w-100">
                    <div className="col-1 m-0 p-0"><FontAwesomeIcon icon={faInfoCircle} className="text-secondary font-size-1 text-center align-top" /></div>
                    <div className="col-11 text-gray font-italic font-size-0-75 pl-0">{ description}</div>
            </div>
        )
} 